/* eslint semi: 1 */

export const addBuilds = builds => {
    return {
        type: 'ADD_BUILDS',
        payload: {
            builds
        }
    };
};

export const toggleAvailableBuilds = () => {
    return {
        type: 'TOGGLE_AVAILABLE_BUILDS',
        payload: {}
    };
};

export const updateContactFirstName = contactFirstName => {
    return {
        type: 'UPDATE_CONTACT_FIRST_NAME',
        payload: {
            contactFirstName
        }
    };
};

export const updateContactLastName = contactLastName => {
    return {
        type: 'UPDATE_CONTACT_LAST_NAME',
        payload: {
            contactLastName
        }
    };
};

export const updateContactEmail = contactEmail => {
    return {
        type: 'UPDATE_CONTACT_EMAIL',
        payload: {
            contactEmail
        }
    };
};

export const updateContactMessage = contactMessage => {
    return {
        type: 'UPDATE_CONTACT_MESSAGE',
        payload: {
            contactMessage
        }
    };
};

export const resetContactData = () => {
    return {
        type: 'RESET_CONTACT_DATA',
        payload: {}
    };
};



/** WEBPACK FOOTER **
 ** ./src/actions/app-actions.js
 **/